import React, { useEffect, useState } from "react";
import { useUpdateTodoMutation } from "../../features/todoApi/todoApiSlice";
import Error from "../ui/Error";
import BounchLoading from "../ui/loaders/BounchLoading";

const UpdateTodoForm = ({ todo, handleModalClose }) => {
  const { text, color, id } = todo;
  const [editText, setEditText] = useState(text);
  const [editColor, setEditColor] = useState(color);
  const [updateTodo, { isLoading, isError, isSuccess }] =
    useUpdateTodoMutation();

  const onSubmit = (e) => {
    e.preventDefault();
    updateTodo({
      id,
      data: {
        text: editText,
        color: editColor,
      },
      complete: false,
    });
  };

  const handleColorChange = (color) => setEditColor(color);

  useEffect(() => {
    if (isSuccess) {
      handleModalClose();
    }
  }, [isSuccess, handleModalClose]);

  return (
    <div className="bg-white shadow-md rounded-md px-3 py-5 min-w-[350px]">
      {isError ? (
        <Error msg={"There was an error"} />
      ) : (
        <form onSubmit={(e) => onSubmit(e)}>
          <label className="font-medium">Todo Title:</label>
          <input
            type="text"
            className="w-full px-2 py-1 border-[2px] outline-none border-violet-400 rounded font-medium mt-1 mb-2"
            onChange={(e) => setEditText(e?.target?.value)}
            value={editText}
            autoFocus
          />
          <span className="font-medium">Select Priority: </span>
          <div className="w-fit mt-1">
            <div
              className="flex gap-2 items-center justify-start cursor-pointer mb-2"
              onClick={() => handleColorChange("green")}
            >
              <div
                className={`h-4 w-4 rounded-full border-2 cursor-pointer hover:bg-green-500 border-green-500 ${
                  editColor === "green" && "bg-green-500"
                }`}
              ></div>
              <span className="text-green-400">Green</span>
            </div>
            <div
              className="flex gap-2 items-center justify-start cursor-pointer mb-2"
              onClick={() => handleColorChange("yellow")}
            >
              <div
                className={`h-4 w-4 rounded-full border-2 cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
                  editColor === "yellow" && "bg-yellow-500"
                }`}
              ></div>
              <span className="text-yellow-400">Yellow</span>
            </div>
            <div
              className="flex gap-2 items-center justify-start cursor-pointer mb-2"
              onClick={() => handleColorChange("red")}
            >
              <div
                className={`h-4 w-4 rounded-full border-2 cursor-pointer hover:bg-red-500 border-red-500 ${
                  editColor === "red" && "bg-red-500"
                }`}
              ></div>
              <span className="text-red-400">Red</span>
            </div>
          </div>

          <div className="flex gap-2 items-center mt-3">
            <button
              className="w-full min-h-[35px] bg-slate-200 rounded shadow-sm py-1 text-base font-medium text-center"
              onClick={handleModalClose}
              type="button"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-full min-h-[35px] bg-sky-500 rounded shadow-sm py-1 text-base font-medium text-center text-white hover:shadow-md transition-all duration-500 overflow-hidden"
            >
              {isLoading ? <BounchLoading /> : "Save"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default UpdateTodoForm;
